import { lazy, Suspense } from "react";
import Header from "./Header";
import Hero from "./Hero";

const Features = lazy(() => import("./Features"));
const PowerFeatures = lazy(() => import("./PowerFeatures"));
const HowItWorks = lazy(() => import("./HowItWorks"));
const SocialProof = lazy(() => import("./SocialProof"));
const Pricing = lazy(() => import("./Pricing"));
const FAQ = lazy(() => import("./FAQ"));
const Footer = lazy(() => import("./Footer"));
const StickyMobileCTA = lazy(() => import("./StickyMobileCTA"));
const ExitIntentPopup = lazy(() => import("./ExitIntentPopup"));
const LiveSignupNotifications = lazy(() => import("./LiveSignupNotifications"));

interface LandingPageProps {
  onCtaClick: () => void;
}

export const LandingPage = ({ onCtaClick }: LandingPageProps) => {
  return (
    <div className="min-h-screen">
      <Header onCtaClick={onCtaClick} />
      <main>
        <Hero onCtaClick={onCtaClick} />
        <Suspense fallback={null}>
          <section id="features">
            <Features />
          </section>
          <PowerFeatures />
          <section id="how-it-works">
            <HowItWorks />
          </section>
          <SocialProof />
          <section id="pricing">
            <Pricing onCtaClick={onCtaClick} />
          </section>
          <FAQ />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <StickyMobileCTA onCtaClick={onCtaClick} />
        <ExitIntentPopup onCtaClick={onCtaClick} />
        <LiveSignupNotifications />
      </Suspense>
    </div>
  );
};
